// extracted by mini-css-extract-plugin
export default {"wrapper":"info-box-module--wrapper--4df28","heading":"info-box-module--heading--9a836","buttonWrapper":"info-box-module--buttonWrapper--ab4f8"};